import { SvgIconProps } from "@mui/material";

export const SinglePageODIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    height="64"
    viewBox="0 0 82 64"
    fill="none"
    {...props}
  >
    <path
      d="M78.5 23.6667H61.8333C60.7283 23.6667 59.6685 23.2277 58.8871 22.4463C58.1057 21.6649 57.6667 20.6051 57.6667 19.5V2.83335"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 11.1667V52.8334C3.5 55.0435 4.37798 57.1631 5.94078 58.7259C7.50358 60.2887 9.6232 61.1667 11.8333 61.1667H70.1667C72.3768 61.1667 74.4964 60.2887 76.0592 58.7259C77.622 57.1631 78.5 55.0435 78.5 52.8334V23.6667L57.6667 2.83336H11.8333C9.6232 2.83336 7.50358 3.71133 5.94078 5.27413C4.37798 6.83694 3.5 8.95655 3.5 11.1667Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_521_8547)">
      <path
        d="M22.75 32.5H34"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.75 40H34"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.75 47.5H34"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_521_8547)">
      <path
        d="M12.5 42H15.5C16.163 42 16.7989 42.2634 17.2678 42.7322C17.7366 43.2011 18 43.837 18 44.5V47.5C18 48.163 17.7366 48.7989 17.2678 49.2678C16.7989 49.7366 16.163 50 15.5 50H12.5V42Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip2_521_8547)">
      <path
        d="M18 31.5C18 30.837 17.7366 30.2011 17.2678 29.7322C16.7989 29.2634 16.163 29 15.5 29H14.5C13.837 29 13.2011 29.2634 12.7322 29.7322C12.2634 30.2011 12 30.837 12 31.5V34.5C12 35.163 12.2634 35.7989 12.7322 36.2678C13.2011 36.7366 13.837 37 14.5 37H15.5C16.163 37 16.7989 36.7366 17.2678 36.2678C17.7366 35.7989 18 35.163 18 34.5V31.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip3_521_8547)">
      <path
        d="M57.75 32.5H69"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.75 40H69"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.75 47.5H69"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip4_521_8547)">
      <path
        d="M53 31.5C53 30.837 52.7366 30.2011 52.2678 29.7322C51.7989 29.2634 51.163 29 50.5 29H49.5C48.837 29 48.2011 29.2634 47.7322 29.7322C47.2634 30.2011 47 30.837 47 31.5V34.5C47 35.163 47.2634 35.7989 47.7322 36.2678C48.2011 36.7366 48.837 37 49.5 37H50.5C51.163 37 51.7989 36.7366 52.2678 36.2678C52.7366 35.7989 53 35.163 53 34.5V31.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip5_521_8547)">
      <path
        d="M52.5 44C52.5 43.4696 52.2893 42.9609 51.9142 42.5858C51.5391 42.2107 51.0304 42 50.5 42H49.5C48.9696 42 48.4609 42.2107 48.0858 42.5858C47.7107 42.9609 47.5 43.4696 47.5 44C47.5 44.5304 47.7107 45.0391 48.0858 45.4142C48.4609 45.7893 48.9696 46 49.5 46H50.5C51.0304 46 51.5391 46.2107 51.9142 46.5858C52.2893 46.9609 52.5 47.4696 52.5 48C52.5 48.5304 52.2893 49.0391 51.9142 49.4142C51.5391 49.7893 51.0304 50 50.5 50H49.5C48.9696 50 48.4609 49.7893 48.0858 49.4142C47.7107 49.0391 47.5 48.5304 47.5 48"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_521_8547">
        <rect width="30" height="30" fill="white" transform="translate(9 25)" />
      </clipPath>
      <clipPath id="clip1_521_8547">
        <rect width="12" height="12" fill="white" transform="translate(9 40)" />
      </clipPath>
      <clipPath id="clip2_521_8547">
        <rect width="12" height="12" fill="white" transform="translate(9 27)" />
      </clipPath>
      <clipPath id="clip3_521_8547">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(44 25)"
        />
      </clipPath>
      <clipPath id="clip4_521_8547">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(44 27)"
        />
      </clipPath>
      <clipPath id="clip5_521_8547">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(44 40)"
        />
      </clipPath>
    </defs>
  </svg>
);
